import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from '../service';
import { UnitAnalyticsCombinedResult } from '../common/models/unitAnalytics';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit {
  returnUrl: string = '';

  filterType: 'ALL' | 'DAY' | 'MONTH' | 'YEAR' = 'DAY';

  // DAY
  selectedDay: string;

  // MONTH — two separate dropdowns
  selectedMonthYear: number;
  selectedMonthNum: number;
  monthNames: { value: number; label: string }[] = [
    { value: 1, label: 'January' },   { value: 2,  label: 'February' },
    { value: 3, label: 'March' },     { value: 4,  label: 'April' },
    { value: 5, label: 'May' },       { value: 6,  label: 'June' },
    { value: 7, label: 'July' },      { value: 8,  label: 'August' },
    { value: 9, label: 'September' }, { value: 10, label: 'October' },
    { value: 11, label: 'November' }, { value: 12, label: 'December' }
  ];

  // YEAR
  selectedYear: number;
  years: number[] = [];

  totalUnitsCreated: number = 0;
  totalGatewayCommissioned: number = 0;
  totalCpib2Commissioned: number = 0;
  totalEpalCustomerDevices: number = 0;
  totalEpalMechanicDevices: number = 0;
  totalEpalGateway: number = 0;

  isLoading = false;

  constructor(private router: Router, private service: Service) {}

  ngOnInit(): void {
    this.returnUrl = sessionStorage.getItem('returnUrl');
    if (this.returnUrl) {
      this.router.navigateByUrl(this.returnUrl);
      return;
    }
    this.initDefaults();
    this.loadAnalytics();
  }

  private initDefaults(): void {
    const now = new Date();
    this.selectedDay = now.toISOString().split('T')[0];

    for (let y = now.getFullYear(); y >= 2019; y--) {
      this.years.push(y);
    }
    this.selectedYear     = now.getFullYear();
    this.selectedMonthYear = now.getFullYear();
    this.selectedMonthNum  = now.getMonth() + 1;
  }

  private getDateRange(): { startDate: string; endDate: string } {
    if (this.filterType === 'ALL') {
      return { startDate: '', endDate: '' };
    } else if (this.filterType === 'DAY') {
      return {
        startDate: `${this.selectedDay}T00:00:00`,
        endDate:   `${this.selectedDay}T23:59:59`
      };
    } else if (this.filterType === 'MONTH') {
      const mm   = String(this.selectedMonthNum).padStart(2, '0');
      const lastDay = new Date(this.selectedMonthYear, this.selectedMonthNum, 0).getDate();
      const dd   = String(lastDay).padStart(2, '0');
      return {
        startDate: `${this.selectedMonthYear}-${mm}-01T00:00:00`,
        endDate:   `${this.selectedMonthYear}-${mm}-${dd}T23:59:59`
      };
    } else {
      return {
        startDate: `${this.selectedYear}-01-01T00:00:00`,
        endDate:   `${this.selectedYear}-12-31T23:59:59`
      };
    }
  }

  onFilterTypeChange(): void {
    this.loadAnalytics();
  }

  onSelectionChange(): void {
    this.loadAnalytics();
  }

  loadAnalytics(): void {
    this.isLoading = true;
    const { startDate, endDate } = this.getDateRange();

    this.service
      .getAnalytics(this.filterType, startDate, endDate)
      .subscribe({
        next: (data: UnitAnalyticsCombinedResult) => {
          this.totalUnitsCreated       = data.unitsCreated.reduce((s, d) => s + d.unitCount, 0);
          this.totalGatewayCommissioned = data.gatewayCommissioned.reduce((s, d) => s + d.unitCount, 0);
          this.totalCpib2Commissioned   = data.cpib2Commissioned.reduce((s, d) => s + d.unitCount, 0);
          this.totalEpalCustomerDevices = data.epalCustomerDevicesCommissioned.reduce((s, d) => s + d.unitCount, 0);
          this.totalEpalMechanicDevices = data.epalMechanicDevicesCommissioned.reduce((s, d) => s + d.unitCount, 0);
          this.totalEpalGateway         = data.epalGatewayCommissioned ? data.epalGatewayCommissioned.reduce((s, d) => s + d.unitCount, 0) : 0;
          this.isLoading = false;
        },
        error: () => {
          this.totalUnitsCreated        = 0;
          this.totalGatewayCommissioned = 0;
          this.totalCpib2Commissioned   = 0;
          this.totalEpalCustomerDevices = 0;
          this.totalEpalMechanicDevices = 0;
          this.totalEpalGateway         = 0;
          this.isLoading                = false;
        }
      });
  }

}